/* global axios */
/* eslint-disable max-classes-per-file */
import ApiClient from './ApiClient';

class TalkviaAgentPauseRulesAPI extends ApiClient {
  constructor() {
    super('talkvia_agent_pause_rules', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { talkvia_agent_pause_rule: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_agent_pause_rule: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

class TalkviaAgentPauseSessionsAPI extends ApiClient {
  constructor() {
    super('talkvia_agent_pause_sessions', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params: { ...params, _t: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
    });
  }

  start(ruleId, note = '') {
    return axios.post(this.url, { rule_id: ruleId, note });
  }

  end(id) {
    return axios.patch(`${this.url}/${id}`, {});
  }

  endCurrent() {
    return axios.post(`${this.url}/end_current`);
  }

  report(params = {}) {
    return axios.get(`${this.url}/report`, { params });
  }
}

export const pauseRulesAPI = new TalkviaAgentPauseRulesAPI();
export const pauseSessionsAPI = new TalkviaAgentPauseSessionsAPI();
